import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";

import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import WelcomeMessage from "@src/course-home/outline-tab/widgets/WelcomeMessage";
import { fetchOutlineTab } from "@src/course-home/data";
import messages from "./messages";

const AnnouncementWidget = ({ courseId, intl }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOutlineTab(courseId));
  }, [dispatch, courseId]);

  return (
    <section className="mb-3" data-testid="announcement-widget">
      <h3 className="h4 m-0 mb-2">{intl.formatMessage(messages.latestAnnouncement)}</h3>
      <WelcomeMessage courseId={courseId} />
    </section>
  );
};

AnnouncementWidget.propTypes = {
  courseId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(AnnouncementWidget);

